<template>
  <div class="vuetify-fz fz-32">
    <v-btn
      v-if="examinationType != 1"
      color="#3b587d"
      class="mb-3 text-white"
      block
      large
      @click="setCommend(['indication']); setCommend(['open'])"> 
      {{ $t('common.indication') }}
    </v-btn>
    <div class="quick-commen">
      <button 
        @click="setCommend(['evas go'])"> 
        Evas go 
      </button>
      <button
        v-if="examinationType != 1" 
        @click="setCommend(['insertion to']); setCommend(['cecum'])"> 
        Insertion to Cecum 
      </button>
      <button 
        v-if="examinationType != 1" 
        @click="setCommend(['proximal time'])"> 
        Proximal Time
      </button>
      <button 
        @click="setCommend(['finish'])"> 
        Finish 
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios';

export default {
  name: 'QuickCommend',

  mounted() {
  },
  methods: {
    setCommend(commend) {
      window.voiceInput(commend)
    },
  },
  computed: {
    ...mapGetters('examinations', [
      'getExaminationData',
    ]),
    examinationType() {
      return this.getExaminationData.examination.examination_typeID
    },
    examinationID() {
            return this.getExaminationData.examination.id
    },
    examination_typeID() {
        return this.getExaminationData.examination.examination_typeID
    },
  }
}
</script>

<style lang="scss">
.quick-commen {
  button {
    display: block;
    width: 100%;
    color: white;
    font-size: 32px;
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 5px;
    background: #232B5E;

    &:hover {
      background: #4c5bbb;
    }
  }

  button + button {
    margin-top: 10px;
  }
}
</style>
